// src/pages/TelefoneLink.js
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import { saveInternationalPhone } from '../utils/phoneUtils';

const TelefoneLink = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fetchData } = useApi();
  const processedToken = useRef(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const phoneToken = searchParams.get('fone');

    if (!phoneToken || processedToken.current === phoneToken) {
      return;
    }

    processedToken.current = phoneToken;

    const capturePhone = async () => {
      try {
        const result = await fetchData(`/TelefoneLink/${encodeURIComponent(phoneToken)}`);
        saveInternationalPhone(result?.telefone);
      } catch (error) {
        console.error('Não foi possível identificar o telefone informado no link.', error);
      } finally {
        searchParams.delete('fone');
        const remainingSearch = searchParams.toString();

        navigate(
          {
            pathname: location.pathname,
            search: remainingSearch ? `?${remainingSearch}` : '',
            hash: location.hash,
          },
          { replace: true }
        );
      }
    };

    capturePhone();
  }, [fetchData, location.hash, location.pathname, location.search, navigate]);

  return null;
};

export default TelefoneLink;
